module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"YW3V619FID","searchOnlyApiKey":"284a94d9daae988d84aaccfa73bb2045","indexName":"content"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/search.json
// module id = 794
// module chunks = 254572558124955